import { memo } from "react";
import { useLocation } from "react-router-dom";
import { checkStepFromCurrentPath } from "app/pages/Stepper/StepperUtils";
import Stepper from "app/pages/.shared/Stepper/Stepper";
import { useIntl } from "react-intl";

const STEPS = [
	{ value: 1, paths: ["/booking/quote"] },
	{ value: 2, paths: ["/booking/payment"] },
	{ value: 3, paths: ["/booking/confirmation"] },
];

const SmartDPStepper = () => {
	const { formatMessage } = useIntl();
	const location = useLocation();

	const stepLabels = STEPS.map(step =>
		formatMessage({ id: `sdp.booking.breadcrumb.step.${step.value}` })
	);
	const currentStep = checkStepFromCurrentPath(STEPS, location?.pathname);

	return <Stepper steps={stepLabels} currentStep={currentStep} />;
};

export default memo(SmartDPStepper);
